module.exports = __webpack_public_path__ + "static/media/07012019001.dd5d60aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/07012019001.png
// module id = 249
// module chunks = 0